export default "__VITE_ASSET__BRSDzO40__"